/* PYNRS: timeline blocks with a video (sections/timeline.liquid).
   Only the selected block's video plays, muted and looping, and only while the timeline is on screen.
   Sources sit in data-src so hidden blocks download nothing until they are first shown. */
(function () {
  function sync(item, inView) {
    var video = item.querySelector('video');
    if (!video) return;
    if (inView && item.classList.contains('is-selected')) {
      if (!video.dataset.loaded) {
        video.querySelectorAll('source[data-src]').forEach(function (source) { source.src = source.dataset.src; });
        video.dataset.loaded = '1';
        video.load();
      }
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () {});
    } else if (!video.paused) {
      video.pause();
    }
  }

  function setup(list) {
    if (list.dataset.pynrsTimelineVideo) return;
    list.dataset.pynrsTimelineVideo = '1';
    var inView = false;
    function run() {
      list.querySelectorAll('.timeline__image--video').forEach(function (item) { sync(item, inView); });
    }
    new IntersectionObserver(function (entries) {
      inView = entries[entries.length - 1].isIntersecting;
      run();
    }, { threshold: 0.25 }).observe(list);
    new MutationObserver(run).observe(list, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  function init(root) {
    (root || document).querySelectorAll('.timeline__image-list').forEach(function (list) {
      if (list.querySelector('.timeline__image--video')) setup(list);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
